<template>
  <div class="fill-height">
    <GameTopbar
      :score="score"
      :clue="clue"
      :active-clue="activeClue"
      @clue="$emit('clue')"
      @close="$emit('close')"
    />

    <v-main class="fill-height">
      <slot />
    </v-main>
  </div>
</template>

<style>
  .pattern {
    background: url('../assets/img/scenarios/pattern.png');
  }
</style>

<script>
import GameTopbar from '@/components/navigation/GameTopbar.vue';

export default {
  name: 'GameLayout',
  props: {
    score: {
      type: [String, Number, Array],
      default: '',
    },
    activeClue: {
      type: Boolean,
      default: true,
    },
    clue: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GameTopbar,
  },
};
</script>
